import * as React from 'react';
import { Sticky, StickyContainer } from 'react-sticky';
import { Spinner } from '../../Spinner';
export var ApiExplorer = function (_a) {
    var doc = _a.doc, title = _a.title, languages = _a.languages;
    React.useEffect(function () {
        window.initApiExplorer(languages);
    }, []);
    var renderContent = function () {
        // If the document hasn't been loaded yet, display a spinner.
        if (!doc || !doc.html || !doc.meta) {
            return React.createElement(Spinner, null);
        }
        return React.createElement("div", { dangerouslySetInnerHTML: { __html: doc.html } });
    };
    return (React.createElement(StickyContainer, null,
        React.createElement("section", { className: "content api-explorer", "data-swiftype-name": "body", "data-swiftype-type": "text", "data-swiftype-index": "true" },
            React.createElement("div", { className: "api-sidebar tocify-wrapper" },
                React.createElement("div", { className: "sticky-nav-placeholder" },
                    React.createElement(Sticky, null, function (_a) {
                        var style = _a.style;
                        return (React.createElement("div", { style: style },
                            React.createElement("div", { className: "sticky-nav" },
                                React.createElement("div", { className: "sticky-nav-selected" },
                                    React.createElement("span", null, "Menu"),
                                    React.createElement("i", { className: "icon-budicon-460" })),
                                React.createElement("div", { id: "toc" },
                                    React.createElement("div", { className: "title" }, title)))));
                    }))),
            React.createElement("div", { className: "page-wrapper" },
                React.createElement("div", { className: "dark-box" }),
                React.createElement("div", { className: "lang-selector-container" },
                    React.createElement(Sticky, null, function (_a) {
                        var isSticky = _a.isSticky, style = _a.style;
                        return (React.createElement("div", { style: style, className: isSticky ? 'sticky lang-mobile-sticky' : '' },
                            React.createElement("div", { className: "lang-selector" },
                                React.createElement("div", { className: "lang-selector-selected" },
                                    React.createElement("span", { className: "language-label" }, "Language:"),
                                    React.createElement("span", { className: "language js-selected-language" }),
                                    React.createElement("i", { className: "icon-budicon-460" })),
                                languages.map(function (language) { return (React.createElement("a", { href: "#".concat(language.key), key: language.key, "data-language-name": language.key }, language.name)); }))));
                    })),
                React.createElement("div", { className: "api-content" }, renderContent())))));
};
